function createObjectURL(url: string) {
	return fetch(url)
		.then((response) => {
			return response.blob();
		})
		.then((blob) => {
			return URL.createObjectURL(blob);
		});
}

export async function downloadAsset({
	assetUrl,
	assetName,
	onError,
}: {
	assetUrl: string;
	assetName: string;
	onError?: () => void;
}) {
	try {
		const a = document.createElement('a');
		a.href = await createObjectURL(assetUrl);
		a.download = assetName;
		document.body.appendChild(a);
		a.click();
		// delete the internal blob reference, to let the browser clear memory from it
		URL.revokeObjectURL(a.href);
		document.body.removeChild(a);
	} catch (error) {
		onError?.();
	}
}
